export const maskValue = (value: string) =>
  value.length > 7 ? `${value.slice(0, 4)}...${value.slice(-3)}` : value
